import { RESEND_INVITE } from '../../../api';
import { SendEmailContainer } from '../SendEmailContainer';

export const SendActivationCodeEmail = ({
  isAppAccount,
}: {
  isAppAccount: boolean;
}) => (
  <SendEmailContainer
    isAppAccount={isAppAccount}
    emailEndpoint={RESEND_INVITE}
    header="Activation code"
    description="Enter your work email to get your personal activation code for the Vault Platform app."
    sendEmailBtnText={'Send invitation'}
    successfulEmailSentHeader="Thank you."
    successfulEmailSentText="If you have an account with us, you will get an email with instructions on how to reset your password. 
    If you don’t immediately see it, please wait a few minutes and refresh your email inbox."
  />
);

export default SendActivationCodeEmail;
